export default __webpack_public_path__ + "static/media/ic_share.0e2e5f5d.svg";